export const CUSTOMER_SERVICE_CONFIG_KEY = 'customer.service.config';

export interface CustomerServiceSide {
  wechatNo: string;
  qrCodeUrl: string;
}

export interface CustomerServiceConfigValue {
  buyer: CustomerServiceSide;
  seller: CustomerServiceSide;
}

const emptySide = (): CustomerServiceSide => ({ wechatNo: '', qrCodeUrl: '' });

export const emptyCustomerServiceConfig = (): CustomerServiceConfigValue => ({
  buyer: emptySide(),
  seller: emptySide(),
});

const parseSide = (value: unknown): CustomerServiceSide => {
  if (!value || typeof value !== 'object') {
    return emptySide();
  }
  const obj = value as Record<string, unknown>;
  return {
    wechatNo: typeof obj.wechatNo === 'string' ? obj.wechatNo : '',
    qrCodeUrl: typeof obj.qrCodeUrl === 'string' ? obj.qrCodeUrl : '',
  };
};

export const parseCustomerServiceConfig = (
  raw: string | undefined
): CustomerServiceConfigValue => {
  if (!raw?.trim()) {
    return emptyCustomerServiceConfig();
  }
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return {
      buyer: parseSide(parsed.buyer),
      seller: parseSide(parsed.seller),
    };
  } catch {
    return emptyCustomerServiceConfig();
  }
};

export const readCustomerServiceSide = (
  configs: Map<string, string>,
  role: 'buyer' | 'seller'
): CustomerServiceSide => {
  const parsed = parseCustomerServiceConfig(configs.get(CUSTOMER_SERVICE_CONFIG_KEY));
  return parsed[role] ?? emptySide();
};
